<template>
    <div class="absolute top-0 right-0 left-0 bottom-0 outline-0 modalDialog">
        <div
            role="presentation"
            class="overlay z-50 w-full h-full bg-black-transparent-7 flex flex-col fixed top-0 bottom-0 left-0 right-0 m-auto justify-center"
        >
            <div
                id="ModalBody"
                class="fixed relative z-30 mx-auto w-full md:w-1/3 text-black left-0 right-0 rounded-lg max-w-120 bg-white"
            >
                <div class="closeIcon absolute" @click.stop="$emit('close-modal')">
                    <span class="material-icons"> close </span>
                </div>
                <div
                    class="modalBody flex flex-col pb-6 items-center justify-center mx-auto w-4/5 pt-12"
                    @click.stop
                >
                    <slot name="dialogHeadImg"></slot>

                    <p class="font-bold mb-3">
                        <slot name="dialogHeading"></slot>
                    </p>

                    <p class="text-sm mb-4">
                        <slot name="dialogDescription"></slot>
                    </p>

                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        transparent: {
            type: Boolean,
            required: false,
        },
    },
    data: () => ({}),
    methods: {
        hideBack(event) {
            event.target.parentElement
                .closest(".modalDialog")
                .classList.add("hidden");
            document.body.classList.remove("noscroll");
        },
    },
};
</script>
